import React, { useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";

const AddFormLibraryTemplate = ({
  Show,
  Hide,
  Title,
  getStudyFormTemplatesData,
  libraryId,
  studyId
}) => {
  const [name, setName] = useState("");
  const [label, setLabel] = useState("");
  const [type, setType] = useState("");
  const [permissionType, setPermissionType] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const addNewStudyFormTemplates = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.name = name;
    userData.label = label;
    userData.type = type;
    userData.permission = permissionType;
    userData.formId = libraryId;
    userData.studyId = studyId;
    let data = await cdiscManagementService.addNewStudyFormTemplates(userData);
    if (data?.statusCode === 200) {
      getStudyFormTemplatesData();
      setName("");
      setLabel("");
      setType("");
      setPermissionType("");
      Hide();
    }
    setButtonLoader(false);
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">
            Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            required
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Name"
          />
        </Form.Group>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">
            Label <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            required
            type="text"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            placeholder="Enter Label"
          />
        </Form.Group>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">
            Type <span className="text-danger">*</span>
          </Form.Label>
          <Form.Select onChange={(e) => setType(e.target.value)}>
            <option value="">Select Type</option>
            <option selected={type === "text"} value="text">
              Text
            </option>
            <option selected={type === "number"} value="number">
              Number
            </option>
            <option selected={type === "date"} value="date">
              Date
            </option>
            <option selected={type === "time"} value="time">
              Time
            </option>
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">
            Permission Type <span className="text-danger">*</span>
          </Form.Label>
          <Form.Select onChange={(e) => setPermissionType(e.target.value)}>
            <option value="">Select Permission Type</option>
            <option selected={permissionType === "require"} value="require">
              Require
            </option>
            <option selected={permissionType === "expected"} value="expected">
              Expected
            </option>
            <option
              selected={permissionType === "permissible"}
              value="permissible"
            >
              Permissible
            </option>
          </Form.Select>
        </Form.Group>
      </Offcanvas.Body>
      <div className="text-end p-2 border-top">
        <button
          disabled={buttonLoader || !name || !label || !type ||!permissionType}
          onClick={addNewStudyFormTemplates}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Adding...
            </div>
          ) : (
            "Add Library Template"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default AddFormLibraryTemplate;
